import { render, staticRenderFns } from "./AllCommunitiesView.vue?vue&type=template&id=90c0abb6&scoped=true&"
import script from "./AllCommunitiesView.vue?vue&type=script&lang=js&"
export * from "./AllCommunitiesView.vue?vue&type=script&lang=js&"
import style0 from "./AllCommunitiesView.vue?vue&type=style&index=0&id=90c0abb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c0abb6",
  null
  
)

export default component.exports